export const systemDefaultRulesSuffix = "system-default-rules";
//# sourceMappingURL=constants.js.map